<template>
  <page-status class="report-detail-viewer" :loading="loading">
    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="案件基本信息" />
      </van-cell>
      <van-cell title="出险时间">{{ detail.accidentDateTime }}</van-cell>
      <van-cell title="出险地点" title-style="flex: 0 0 auto;">
        {{ detail.accidentDetailAddress }}
      </van-cell>
      <van-cell title="出险原因">{{ detail.accidentReason }}</van-cell>
    </van-cell-group>

    <van-cell-group style="margin-top: 12px">
      <van-cell>
        <cell-header slot="title" title="案件进度" />
      </van-cell>
      <van-steps
        direction="vertical"
        :active="activeIndex"
        active-color="#108ee9"
      >
        <van-step>
          <div class="step-title">出险人发起报案申请</div>
        </van-step>
        <van-step>
          <div class="step-title">报案成功</div>
          <div class="step-desc">报案号：{{ detail.reportNo }}</div>
        </van-step>
        <van-step>
          <div class="step-title">查勘赔案中</div>
        </van-step>
        <van-step>
          <div class="step-title">审核理赔资料</div>
        </van-step>
        <van-step>
          <div class="step-title">审核结束</div>
        </van-step>
      </van-steps>
    </van-cell-group>

    <div class="footer">
      <page-footer />
    </div>
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import * as constants from '@/utils/constants';
import * as services from '@/services';

export default {
  name: 'ReportDetail',
  components: {
    PageStatus,
    CellHeader,
    PageFooter,
  },

  data() {
    return {
      loading: true,
      detail: {},
      activeIndex: -1,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { reportNo, certType, certNo } = this.$route.query;

      const { CaseStatus } = constants;
      const stepIndex = {
        [CaseStatus.CS001]: 1,
        [CaseStatus.CS002]: 2,
        [CaseStatus.CS003]: 3,
        [CaseStatus.CS004]: 3,
        [CaseStatus.CS005]: 3,
        [CaseStatus.CS006]: 4,
        [CaseStatus.CS007]: 4,
        [CaseStatus.CS008]: 4,
        [CaseStatus.CS009]: 4,
      };

      services.getReport(reportNo, certType, certNo).then(res => {
        this.activeIndex = stepIndex[res.data.caseStatus] || -1;
        this.detail = res.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="less">
.report-detail-viewer {
  display: flex;
  min-height: 100%;
  flex-direction: column;

  .title-center {
    align-self: center;
  }

  .step-desc {
    color: #969799;
  }

  .footer {
    margin-top: auto;
  }
}
</style>
